import * as moment from 'moment';
import { DateRangeFilterValue } from '../../../shared/time-frame-filter/timeframe-filter.component';
import { SampleTrackerData, StudyGroupInfo } from '../../group-info/study-group-info';
import { dataMember, typedArray } from 'santee-dcts';

export class ReportData {
    @dataMember()
    public reportID?: string;
    @dataMember()
    public reportContent?: string;
    @dataMember()
    public id?: string;
    @dataMember()
    public reportGUID?: string;
    @dataMember()
    public generatedReportType?: string;
    @dataMember()
    public scheduledReportType?: string;
    @dataMember()
    public generatedReportName?: string;
    @dataMember()
    public scheduledReportName?: string;
    @dataMember()
    public nextScheduledDateTime?: string | Date;
    @dataMember()
    public reoccurencePattern?: string;
    @dataMember()
    public activeFlag?: boolean;
    @dataMember()
    public notifyFlag?: boolean;
    @dataMember()
    public reportStatus?: string;
    @dataMember()
    public completedDateTime?: string | Date;
    @dataMember()
    public requestedDateTime?: string | Date;
    @dataMember()
    public generatedReportContent?: string;
    @dataMember()
    public scheduledReportContent?: string;
    @dataMember()
    public isRead?: boolean;
    @dataMember()
    public recordCount?: number;
    @dataMember()
    public fileName?: string;
    @dataMember()
    public folderName?: string;
    @dataMember()
    public storageLocation?: string;
    @dataMember()
    public scheduledContent?: string;
    @dataMember()
    public filterContent?: string;
    @dataMember()
    public isGeneratedNotSavedReport: boolean;
    public rowSelected?: boolean;
}

export interface GridFilter {
    timeframeFilter?: DateRangeFilterValue;
    selectedProtocol?: SampleTrackerData;
    selectedStudyGroup?: StudyGroupInfo;
}

export interface ReportRequestInfo {
    fromDate?: moment.MomentInput;
    toDate?: moment.MomentInput;
    loadLatestReports?: boolean;
    latestReportsCount?: number;
    actionName?: string;
    loadAllData?: boolean;
}